import gql from 'graphql-tag'

export const GET_BLOG_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
    $query: String
    $public: Boolean = true
  ) {
    getBlogPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
        query: $query
        public: $public
      }
    ) {
      hasMore
      total
      items {
        id
        titleEn
        titleRu
        titleKg
        timeToRead
        wordCount
      }
    }
  }
`;

export const GET_BLOG_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getBlog (
      data: {
        id: $id
      }
    ) {
      id
      alt
      titleEn
      titleKg
      titleRu
      thesisEn
      thesisKg
      thesisRu
      tagsEn
      tagsKg
      tagsRu
			user {
				shortFullName
			}
      public
      timeToRead
      wordCount
      coverImage
      createdAt
    }
  }
`;

export const GET_BLOG_CONTENT_EN_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getBlog (
      data: {
        id: $id
      }
    ) {
      id
      alt
      titleEn
      contentEn
      user {
        shortFullName
      }
    }
  }
`;

export const GET_BLOG_CONTENT_RU_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getBlog (
      data: {
        id: $id
      }
    ) {
      id
      alt
      titleRu
      contentRu
      user {
        shortFullName
      }
    }
  }
`;

export const GET_BLOG_CONTENT_KG_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getBlog (
      data: {
        id: $id
      }
    ) {
      id
      alt
      titleKg
      contentKg
      user {
        shortFullName
      }
    }
  }
`;
